var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnderConstruction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 593,
    height: 642,
    viewBox: "0 0 593 642",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3673_11111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.588 233.81L405.82 257.158L414.941 262.464",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.278 245.394L434.677 262.48",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.375 171.319L503.734 154.216L503.505 154.077L493.886 148.534L493.69 148.428L483.614 142.6L474.15 137.138L424.757 108.631L414.933 102.958L405.061 108.631L355.733 136.959L352.565 138.779L352.312 138.926L276.796 182.29L345.853 222.365L346.065 222.487",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.065 222.487L345.852 222.365L276.796 182.29L276.755 194.119L276.796 194.144L335.964 228.292L345.852 233.998",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.588 233.81L405.82 257.158L414.941 262.464",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.677 273.868L443.823 268.603L464.278 256.782L503.57 234.104L562.983 199.809V188.413",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.278 245.394L434.677 262.48",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.588 245.394L395.866 262.872L414.941 273.876",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.278 325.372L434.678 342.458",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.942 342.441L365.589 313.796",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.964 228.292L296.435 250.986",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.852 302.342L336.544 296.938H336.535L316.326 285.207",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.064 222.487L345.853 222.61",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.942 353.862L365.589 325.372",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.942 342.441L365.589 313.796",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.852 313.975L326.41 302.759L306.16 291.069",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.326 285.207L336.535 296.938H336.544L345.852 302.342",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.278 325.372L434.678 342.458",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.983 279.787L513.092 308.587L464.278 336.768L464.172 336.825L434.678 353.854",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.278 394.353L434.67 411.439",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.732 377.062L355.178 376.744",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.589 382.777L374.424 387.912L414.942 411.423",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.543 296.938H336.536",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.628 338.123L325.708 359.642L345.853 371.324",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.411 302.759L288.628 324.457",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.177 328.155L276.796 331.249L282.177 334.376",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.942 422.843L365.589 394.353",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.732 377.062L355.178 376.744",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.589 382.777L374.424 387.912L414.942 411.423",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.178 334.376L276.796 331.249L276.772 337.641",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.551 359.128L315.55 365.471L345.118 382.54L345.853 382.965",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.628 338.123L325.708 359.642L345.853 371.324",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.278 394.353L434.67 411.439",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.983 348.776L523.919 371.324L484.52 394.059L475.212 399.439L464.278 405.749L434.67 422.835",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.278 450.836L434.669 467.922",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.941 467.906L365.588 439.252",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.853 427.807L325.504 416.002L306.388 404.9L276.796 387.732L315.55 365.471",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.278 336.89L464.172 336.825",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.941 479.326L365.588 450.844",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.941 467.906L365.588 439.252",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.852 427.807L325.504 416.002L306.388 404.9L276.796 387.732L276.755 399.561L276.796 399.586L296.206 410.786L315.338 421.831H315.346L345.852 439.448",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.278 450.836L434.669 467.922",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.983 405.259L464.278 462.232L434.669 479.318",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.941 524.152L365.588 495.498",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.853 484.053L276.796 443.971L315.338 421.831H315.346",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.278 507.074L434.669 524.16",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.278 507.074L434.669 524.16",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.983 450.101V461.498L464.278 518.47L430.595 537.916L429.443 538.577L424.813 541.255H424.805H424.797L356.059 501.58L355.733 501.384L345.852 495.686L276.755 455.799L276.796 444.811V443.971L345.852 484.053",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.941 524.152L365.588 495.498",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.892 357.144V450.493L276.796 444.811V443.97V421.986V399.586V387.732V378.099",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.796 228.324V194.144V182.29V114.354L266.892 120.044V222.602",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.892 242.259V229.402",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.796 239.712V235.133",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.892 262.986V261.427",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.796 296.693V331.249V337.633",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.892 343.356V290.971",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.892 357.144V450.493L257.02 444.795V433.407V285.273",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.892 343.356V290.971",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.02 251.117V248.3",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.892 222.602V120.044L257.02 114.354V216.904",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.02 236.488V223.687",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.892 242.259V229.402",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.892 262.986V261.427",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.788 114.354L266.892 108.656L257.02 114.354L266.892 120.052L276.788 114.354Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.733 57.275V137.04L345.632 142.6V62.9731L355.733 57.275Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.997 57.275V148.281L345.632 142.6V62.9731L335.997 57.275Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.733 57.275L345.861 51.5768L335.997 57.275L345.632 62.9731L355.733 57.275Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.933 102.958V11.8044L424.822 6.10632L424.748 108.623L414.933 102.958Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.061 6.10632L414.933 11.8044V102.958L405.061 108.623V6.10632Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.822 6.10631L414.933 0.408203L405.061 6.10631L414.933 11.8044L424.822 6.10631Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.278 211.205V518.862L562.975 461.889V154.233L464.278 211.205Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.822 211.214L414.941 205.516V535.557L424.822 541.263V211.214Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.678 205.516L424.822 211.214V541.263L434.669 535.557L434.678 205.516Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.941 205.515L424.805 199.809L434.678 205.515L424.822 211.214L414.941 205.515Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.733 159.939L345.844 165.629L355.733 171.335L365.605 165.637L355.733 159.939Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.733 171.335V501.768L365.589 496.07V165.637L355.733 171.335Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.844 165.629V496.07L355.733 501.768V171.335L345.844 165.629Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.975 154.233V85.8635L553.111 91.5616V159.931L562.975 154.233Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.239 85.8635L553.111 91.5616V159.931L543.223 165.637L543.239 85.8635Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.975 85.8635L553.111 80.1735L543.239 85.8635L553.111 91.5616L562.975 85.8635Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.022 40.2867L493.894 45.9849L484.202 51.5768L474.15 45.9849L484.022 40.2867Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.606 142.6V51.5768L493.895 45.9849V148.534L483.606 142.6Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.15 45.9849L483.606 51.5768V142.6L474.15 137.146V45.9849Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.886 114.354V148.281L533.375 171.319L543.223 165.637L543.231 142.836L493.886 114.354V148.306V148.534L503.505 154.077L503.734 154.216L533.375 171.319",
    fill: "#0000FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.983 188.413V154.233",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.927 148.281L484.047 153.971L493.804 159.604L503.734 153.947L493.927 148.281Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.804 159.604V193.801L503.734 188.144V153.947L493.804 159.604Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.047 153.971V199.515L493.804 193.801V159.604L484.047 153.971Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.206 410.786L276.796 421.986",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.983 439.17L592.592 456.191L424.814 553.051L237.283 444.795L257.019 433.407",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.732 376.418L355.178 376.744",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.853 382.124L345.118 382.54",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.283 456.191V444.795L424.822 553.051L592.584 456.191V467.587L424.822 564.431L237.283 456.191Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.82 450.493L452.822 529.76",
    stroke: "#0000FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.057 438.811L470.059 518.079",
    stroke: "#0000FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.878 465.791L453.532 455.677",
    stroke: "#0000FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.214 482.176L457.86 472.012",
    stroke: "#0000FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.705 499.107L462.294 488.772",
    stroke: "#0000FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.131 515.817L466.777 505.686",
    stroke: "#0000FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0166 461.889V473.277L79.353 501.76L79.3693 490.372L30.0166 461.889Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.586 456.191L79.3694 490.372L79.353 501.76L138.586 467.588V456.191Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0166 461.889L88.7597 427.431L138.586 456.191L79.3693 490.372L30.0166 461.889Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2334 120.052L59.625 137.146V182.723L89.2334 165.629V120.052Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0166 120.052V165.629L59.625 182.723V137.146L30.0166 120.052Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0166 120.052L59.6331 102.958L89.2333 120.052L59.625 137.146L30.0166 120.052Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4971 177.025L79.3692 182.723L128.714 154.233L89.2333 131.448V165.629L69.4971 177.025Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3691 182.723V194.119L128.714 165.629V154.233L79.3691 182.723Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.625 182.723L79.3693 194.119V182.723L69.4972 177.025L59.625 182.723Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0166 131.44L0.408203 114.354L49.7609 85.8635L89.2414 108.656L79.3693 114.354",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0166 131.44L0.408203 114.354V125.75L30.0166 142.836",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3693 114.354L89.2415 108.656V120.044L59.625 137.138",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.619 243.851L276.796 239.712L285.052 244.48",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.5 251.084L326.108 268.178L286.628 290.963L237.283 262.488L243.571 258.864",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.469 249.704L251.712 254.17",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.283 273.876V262.48L286.628 290.971L286.595 302.342L237.283 273.876Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.108 268.178V279.574L286.595 302.342L286.628 290.971L326.108 268.178Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.323 247.451L263.34 247.476L282.798 281.787L286.628 279.795L266.908 245.386",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.315 247.451L266.908 245.386L128.714 165.629L125.717 167.368L263.323 247.451",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.709 167.359L263.315 247.451L282.798 281.787L106.25 178.601L111.052 175.825L270.125 268.178L261.952 251.117L120.516 170.364L125.709 167.359Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.91 174.176L267.921 263.582L270.125 268.178L111.052 175.825L113.91 174.176Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.628 233.998L306.364 268.178L303.604 269.778L283.582 235.753L286.628 233.998Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2334 120.052L286.628 233.998L283.582 235.753L89.2334 123.791V120.052Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.497 249.908L303.604 269.77L283.582 235.753L89.2417 123.799V131.448L90.5074 132.183L128.714 154.232V161.539V165.629L126.746 166.763",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.714 161.539L293.046 257.533L280.716 237.41L90.5073 127.293V132.183L128.714 154.232V161.539Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.178 299.795V345.372L286.595 347.96V302.342L282.178 299.795Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.628 301.175V346.784L286.595 347.96V302.342L288.628 301.175Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.628 342.743L300.313 349.487L293.071 353.666L271.383 340.76L278.291 336.776L282.178 339.021",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.071 353.666L300.314 368.556L307.001 364.695L300.314 349.487L293.071 353.666Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.383 340.76L261.772 346.311L278.291 381.267L300.313 368.556L293.071 353.666L271.383 340.76Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7012 179.874V465.081L59.625 467.587V182.723L54.7012 179.874Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.625 467.587L61.993 466.216V184.086L59.625 182.723V467.587Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4292 191.213V476.412L79.353 478.918V194.054L74.4292 191.213Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.353 478.918L81.721 477.555V192.756L79.353 194.054V478.918Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.501 181.67V460.493L108.978 461.889V180.192L111.501 181.67Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.977 461.889L107.026 460.763V179.049L108.977 180.192V461.889Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4973 188.421L61.9932 192.748",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4293 196.781L61.9932 204.144",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4293 219.785L61.9932 227.141",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4293 254.178L61.9932 261.533",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4293 288.571L61.9932 295.926",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.71 189.874V449.114L82.4395 446.567V192.413L86.71 189.874Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.71 449.114L88.7595 447.93V188.691L86.71 189.874V449.114Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9932 185.572L74.4293 208.177L61.9932 215.54",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9932 215.54L74.4293 238.153L61.9932 245.508",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9932 245.508L74.4293 268.121L61.9932 275.485",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9932 275.485L74.4293 298.089L61.9932 305.453",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9932 305.453L74.4293 328.066L61.9932 335.421",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9932 335.421L74.4293 358.034L61.9932 365.397",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9932 365.397L74.4293 388.002L61.9932 395.365",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9932 395.365L74.4293 417.97L61.9932 425.333",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9932 425.333L74.4293 447.946L61.9932 455.301",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1735 185.572L107.026 207.034L88.7598 197.287",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7595 207.034L107.026 238.782L88.7595 229.034V239.157L107.026 270.782L88.7595 260.905V271.28L107.026 302.906L88.7595 292.252V302.636L107.026 334.776L88.7595 324.155V335.421L107.026 366.524L88.7595 356.025V367.52L107.026 398.524L88.7595 387.896V399.145L107.026 430.019L88.7595 419.766V430.64L107.026 460.763L86.71 449.114",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.026 184.666L81.7207 226.936L107.026 212.332V216.161L81.7207 261.125L107.026 246.512V250.406L81.7207 295.305L107.026 280.701V283.656L81.7207 318.098L107.026 303.485V311.649L81.7207 352.278L107.026 337.674V343.527L81.7207 386.467L107.026 371.854V378.148L81.7207 420.647L107.026 406.035V411.268L81.7207 443.44L107.026 428.827V434.64L81.7207 466.224L107.026 451.62",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.058 578.007V581.533L204.237 596.644V593.003L178.058 578.007Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.701 578.007L204.237 593.003V596.644L230.701 581.509V578.007Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.743 571.566L230.702 578.007L204.237 593.011L178.058 578.007L190.217 570.782",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.077 537.859L187.408 578.007C187.408 578.007 191.784 585.631 204.392 585.631C217 585.631 222.422 578.007 222.422 578.007L205.772 537.834C205.274 536.634 203.559 536.65 203.086 537.859H203.077Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.264 622.963V626.481L283.443 641.592V637.959L257.264 622.963Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.899 622.963L283.443 637.959V641.592L309.899 626.465V622.963Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.941 616.522L309.908 622.963L283.443 637.959L257.264 622.963L269.423 615.738",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.275 582.815L266.605 622.963C266.605 622.963 270.982 630.587 283.59 630.587C296.197 630.587 301.619 622.963 301.619 622.963L284.97 582.79C284.472 581.59 282.757 581.607 282.283 582.815H282.275Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.278 256.782V211.205L562.975 154.232L562.689 199.515L464.278 256.782Z",
    fill: "#0000FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.278 325.372L562.983 269.844",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.278 393.961L562.983 338.425",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.278 450.844L562.983 395.308",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.983 450.101L464.278 507.074",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3673_11111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 593,
    height: 642,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderConstruction);
export default __webpack_public_path__ + "static/media/under_construction.b6b91fe8306ac4d221c9a820baa59af8.svg";
export { ForwardRef as ReactComponent };